module.exports = __webpack_public_path__ + "img/nt51-00a-80-1_2.prt.43955681.jpg";